import { combineReducers } from 'redux'
import auth from './auth'
import user from './user'
import organization from './organization'
import storage from './storage'
import channel from './channel'
import group from './group'
import modal from './modal'
import tag from './tag'
import upload from './upload'
import download from './download'
import division from './division'

export default combineReducers({
  auth,
  user,
  organization,
  storage,
  channel,
  group,
  modal,
  tag,
  upload,
  download,
  division
})



// WEBPACK FOOTER //
// ./src/store/reducers/index.js